// extracted by mini-css-extract-plugin
module.exports = {"heading":"WarrantyInfo_heading__lMqbQ","text":"WarrantyInfo_text__UxpWX"};